var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserNoAccSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13.5352H10C7.2 13.5352 5 15.7352 5 18.5352V21.5352C5 22.1352 5.4 22.5352 6 22.5352C6.6 22.5352 7 22.1352 7 21.5352V18.5352C7 16.8352 8.3 15.5352 10 15.5352H14C15.7 15.5352 17 16.8352 17 18.5352V21.5352C17 22.1352 17.4 22.5352 18 22.5352C18.6 22.5352 19 22.1352 19 21.5352V18.5352C19 15.7352 16.8 13.5352 14 13.5352Z",
    fill: "#495680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12.5352C14.8 12.5352 17 10.3352 17 7.53516C17 4.73516 14.8 2.53516 12 2.53516C9.2 2.53516 7 4.73516 7 7.53516C7 10.3352 9.2 12.5352 12 12.5352ZM12 4.53516C13.7 4.53516 15 5.83516 15 7.53516C15 9.23516 13.7 10.5352 12 10.5352C10.3 10.5352 9 9.23516 9 7.53516C9 5.83516 10.3 4.53516 12 4.53516Z",
    fill: "#495680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserNoAccSvg);
export default __webpack_public_path__ + "static/media/iconUserNoAccSvg.b09acfb5240e2f2c5d58dd9328fcfa36.svg";
export { ForwardRef as ReactComponent };